import { CLUMSE_SEARCH_FEE_FAQ_ANSWER } from "../lib/procurementPricing";

/**
 * Plain-language homepage FAQs (also used for SEO FAQ schema).
 * Keep wording simple - avoid internal product jargon.
 */
export const HOME_PAGE_FAQS = [
  {
    q: "How does pricing work?",
    a:
      "Start with a free diagnosis with no commitment. When you want us to find and compare vetted local pros, you pay a one-time flat $49 search fee. There is no monthly subscription. You never pay a percentage of the contractor's invoice.",
  },
  {
    q: "How much does a search cost?",
    a: CLUMSE_SEARCH_FEE_FAQ_ANSWER,
  },
  {
    q: "Are there different pricing tiers?",
    a: CLUMSE_SEARCH_FEE_FAQ_ANSWER,
  },
  {
    q: "Is there a monthly fee?",
    a:
      "No. Your account is free. You pay only the flat $49 search fee when you want bids from vetted local pros.",
  },
  {
    q: "Do you guarantee I'll get bids?",
    a:
      "Yes. We guarantee three comparable bids from vetted local pros. If we cannot deliver that, we refund your search fee in full.",
  },
  {
    q: "Do I pay the contractor through Clumse?",
    a:
      "No. You pay Clumse the search fee upfront, then work directly with whichever pro you choose. You get their name and number and can negotiate on your own as well.",
  },
  {
    q: "What's included in the free diagnosis?",
    a:
      "We help you figure out what's wrong, estimate parts and labor, and show what similar repairs typically cost in your area. This is completely free.",
  },
  {
    q: "Do you take a cut of my savings?",
    a:
      "No. You keep 100% of the money you save. We charge only the flat $49 search fee to run the search, never a percentage of your contractor invoice.",
  },
  {
    q: "Can I get multiple diagnoses for free?",
    a:
      "Yes. Diagnose as many repairs as you want for free. You only pay the search fee when you want us to dispatch a vetted pro search for a specific job.",
  },
  {
    q: "How do I get started?",
    a:
      "Create your free account and describe what needs fixing. We walk you through the diagnosis and show estimated costs before you commit to a search.",
  },
  {
    q: "Is my information secure?",
    a:
      "Yes. We use HTTPS encryption, secure data storage, and process payments through Stripe. We never sell your personal information.",
  },
];
